import script from './SdsTransition.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',_vm._g({attrs:{"name":_vm.name,"mode":_vm.mode,"appear":_vm.appear,"css":_vm.name !== 'onlyJSHooks',"duration":_vm.skipTransition ? 0 : null}},_vm.JSHooks),[_vm._t("default")],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f119eae6_0", { source: ".fade-enter-active[data-v-f119eae6],.fade-leave-active[data-v-f119eae6]{transition-property:opacity;transition-duration:.3s;transition-timing-function:ease-in-out}.fade-enter[data-v-f119eae6],.fade-leave-to[data-v-f119eae6]{opacity:0}.fadeSlideLeft-enter-active[data-v-f119eae6],.fadeSlideLeft-leave-active[data-v-f119eae6]{transition-property:opacity,transform;transition-duration:.3s;transition-timing-function:ease-in-out}@media (prefers-reduced-motion){.fadeSlideLeft-enter-active[data-v-f119eae6],.fadeSlideLeft-leave-active[data-v-f119eae6]{transition-property:opacity}}.fadeSlideLeft-enter[data-v-f119eae6],.fadeSlideLeft-leave-to[data-v-f119eae6]{opacity:0;transform:translateX(-20px)}@media (prefers-reduced-motion){.fadeSlideLeft-enter[data-v-f119eae6],.fadeSlideLeft-leave-to[data-v-f119eae6]{transform:translateX(0)}}.fadeSlideTop-enter-active[data-v-f119eae6],.fadeSlideTop-leave-active[data-v-f119eae6]{transition-property:opacity,transform;transition-duration:.3s;transition-timing-function:ease-in-out}@media (prefers-reduced-motion){.fadeSlideTop-enter-active[data-v-f119eae6],.fadeSlideTop-leave-active[data-v-f119eae6]{transition-property:opacity}}.fadeSlideTop-enter[data-v-f119eae6],.fadeSlideTop-leave-to[data-v-f119eae6]{opacity:0;transform:translateY(-20px)}@media (prefers-reduced-motion){.fadeSlideTop-enter[data-v-f119eae6],.fadeSlideTop-leave-to[data-v-f119eae6]{transform:translateY(0)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-f119eae6";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
